var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddgroupiconHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3320",
    "data-name": "Group 3320",
    transform: "translate(-987 -5976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(995.123 5984.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2718",
    "data-name": "Group 2718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M10.278,18.778a.511.511,0,0,1-.511-.511v-1.2a1.9,1.9,0,0,0-1.893-1.893H3.065a1.9,1.9,0,0,0-1.893,1.893v1.2a.511.511,0,1,1-1.022,0v-1.2A2.919,2.919,0,0,1,3.065,14.15H7.874a2.919,2.919,0,0,1,2.915,2.915v1.2A.511.511,0,0,1,10.278,18.778Z",
    transform: "translate(-0.15 -6.937)",
    fill: "#00246A",
    stroke: "#00246A",
    strokeLinecap: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    d: "M2.065-.85A2.915,2.915,0,1,1-.85,2.065,2.919,2.919,0,0,1,2.065-.85Zm0,4.809A1.893,1.893,0,1,0,.172,2.065,1.9,1.9,0,0,0,2.065,3.959Z",
    transform: "translate(3.254 0.85)",
    fill: "#00246A",
    stroke: "#00246A",
    strokeLinecap: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M21.464,18.83a.511.511,0,0,1-.511-.511v-1.2a1.893,1.893,0,0,0-1.42-1.831.511.511,0,1,1,.255-.989,2.915,2.915,0,0,1,2.186,2.82v1.2A.511.511,0,0,1,21.464,18.83Z",
    transform: "translate(-7.729 -6.989)",
    fill: "#00246A",
    stroke: "#00246A",
    strokeLinecap: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M15.66,7.96a.511.511,0,0,1-.126-1.006,1.893,1.893,0,0,0,0-3.668.511.511,0,0,1,.253-.99,2.915,2.915,0,0,1,0,5.648A.512.512,0,0,1,15.66,7.96Z",
    transform: "translate(-6.134 -2.202)",
    fill: "#00246A",
    stroke: "#00246A",
    strokeLinecap: "round",
    strokeWidth: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_210",
    "data-name": "Ellipse 210",
    transform: "translate(987 5976)",
    fill: "none",
    stroke: "#00246A",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.1,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddgroupiconHover);
export default __webpack_public_path__ + "static/media/addgroupiconHover.5011bb88ecec9141a4749542105b0e08.svg";
export { ForwardRef as ReactComponent };